export default __webpack_public_path__ + "static/media/Download-Icon.de0caca4.svg";